import React, { createContext, useState } from "react";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

interface EditShippingAddressActionContextType {
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: SuperOrder;
  setElement: (element: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const EditShippingAddressActionContext = createContext<EditShippingAddressActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new SuperOrder(),
  setElement: () => {},
  showModal: false,
  setShowModal: () => {},

});

interface EditShippingAddressActionProviderProps {
  children: React.ReactNode;
}

export const EditShippingAddressActionProvider: React.FC<EditShippingAddressActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<SuperOrder>(new SuperOrder());
  const [showModal, setShowModal] = useState(false);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    showModal,
    setShowModal,
  };
  return (
    <EditShippingAddressActionContext.Provider value={value}>
      {children}
    </EditShippingAddressActionContext.Provider>
  );
};
